import { useState } from 'react'
import { Popover } from 'react-tiny-popover'

import style from '../../../styles/Weather/weather_location'
import { track } from '../../utilities/track'
import ChooseWeatherLocation from './ChooseWeatherLocation'

import { useRouter } from 'next/router'

const EditWeatherLocation = ({ locationChanged }) => {
  const router = useRouter()
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  const onClick = () => {
    setIsPopoverOpen(!isPopoverOpen)
    track('Pencil_icon', { isOpen: !isPopoverOpen })
  }

  return (
    <>
      <Popover
        isOpen={isPopoverOpen}
        positions={['bottom']}
        align={'end'}
        containerClassName={`popover-container ${router.query?.layout === 'false' ? 'no-layout' : ''}`}
        content={
          <ChooseWeatherLocation
            locationChanged={location => {
              locationChanged(location)
              setIsPopoverOpen(false)
            }}
            close={() => setIsPopoverOpen(false)}
          />
        }>
        <img onClick={onClick} className='edit-icon' src='/edit-icon.svg' alt='' />
      </Popover>
      <style jsx>{style}</style>
    </>
  )
}

export default EditWeatherLocation
